<template>
  <Main>
    <CourtForm
      :form="form"
      @submit="submit"
      :segment-list="segment"
      @previous-page="previousPage"
    />
    <ModalCourt
      type="tribunal"
      v-model="modal"
      @submit="newCourt"
      @close="redirectListCourt"
    />
    <ModalCancelCourt
      @close="closeModalCancel"
      v-model="modalCancelCourt"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import CourtForm from "../components/CourtForm";
import ModalCourt from "../components/ModalCourt";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { mapActions, mapState } from "vuex";
import ModalCancelCourt from "../../insurance_company/components/ModalCancelInsurance";
import FormMixin from "@/mixins/FormMixin";
export default {
  beforeRouteLeave(to, from, next) {
    this.modalCancelCourt = true;
    this.nextRoute = to;
    if (this.cancel || this.formIsPristineCommon(this.form, this.cloneForm))
      next();
  },
  data: () => ({
    form: {
      ativo: true
    },
    modal: false,
    modalCancelCourt: false,
    nextRoute: null,
    cancel: false,
    cloneForm: {}
  }),
  components: {
    CourtForm,
    ModalCourt,
    ModalCancelCourt
  },
  mixins: [CommonPayload, LoadingRequest, FormMixin],
  created() {
    this.fetchSegment();
  },
  computed: {
    ...mapState("court", ["segment"])
  },
  methods: {
    ...mapActions("court", ["requestNewCourt", "requestSegment"]),
    fetchSegment() {
      this.withLoading(this.requestSegment());
    },
    submit(form) {
      //TODO: Fazer integração
      this.withLoading(
        this.requestNewCourt(form).then(() => (this.modal = true))
      );
    },
    newCourt() {
      this.modal = false;
      this.form = {};
    },
    redirectListCourt() {
      this.modal = false;
      this.cancel = true;
      this.previousPage();
    },
    previousPage() {
      this.$router.push({ name: "list court" });
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancelCourt = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    }
  }
};
</script>
